import React, { useContext } from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { AdminWorkspace24Icon, ArrowDownIcon, ProfileOutline24Icon,
   LogoutOutline24Icon } from 'assets/icons'
import Popover from 'src/components/utils/Popover'
import { useMe, useOrganization } from 'src/graphql/hooks'
import NotebookContext from 'src/libraries/contexts/Notebook'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

// TODO: Move this to seperate file when more sure
// PR #757
const ToolsBlockButton = ({ icon, name, onClick }) => (
   <View onClick={onClick} textAlign="center" margin="10px 0px">
      <View
         display="inline-flex"
         justifyContent="center"
         alignItems="center"
         height="30px"
         width="30px"
         marginBottom="10px">
         {icon}
      </View>
      <Text color="#888" size="1">
         {name}
      </Text>
   </View>
)

ToolsBlockButton.propTypes = {
   icon: PropTypes.node.isRequired,
   name: PropTypes.string.isRequired,
   onClick: PropTypes.func
}

ToolsBlockButton.defaultProps = {
   onClick: PropTypes.func
}

const ToolsBlock = ({
   popoverAnchorOriginHorizontal,
   popoverAnchorOriginVertical,
   popoverMargin
}) => {
   const { protoTheme, setProtoTheme } = useContext(ProtoThemeContext)
   const { setUseFacingPages } = useContext(NotebookContext)

   const { me, isLoggedIn } = useMe()
   const { organization } = useOrganization()
   const isAdmin = organization.currentUserCanEdit
   const isMotherUser = me?.email?.endsWith('@mother.co')

   if (!isLoggedIn) {
      return null
   }

   return (
      <Popover.Provider>
         <Popover.Anchor>
            <View
               flex="0 0 auto"
               display="flex"
               justifyContent="flex-end"
               alignItems="center"
               width="30px"
               height="30px"
               paddingRight="3px"
               borderRadius="2px">
               <ArrowDownIcon
                  width="12px"
                  height="12px"
                  color="#777"
                  strokeWidth="2px"
               />
            </View>
         </Popover.Anchor>
         <Popover.View
            anchorOriginHorizontal={popoverAnchorOriginHorizontal}
            anchorOriginVertical={popoverAnchorOriginVertical}
            margin={popoverMargin}
            width="300px">
            <View
               position="relative"
               bottom="-2px"
               right="-5px"
               float="left"
               width="100%"
               borderRadius="6px"
               margin="5px 0px"
               boxShadow="3px 3px 20px rgba(0,0,0,0.2)"
               backgroundColor="rgba(18,18,20,0.98)">
               <View float="left" width="100%" padding="15px">
                  <Grid columns="3" spacing="5px">
                     <GridCell>
                        <Link to="/profile">
                           <ToolsBlockButton
                              icon={(
                                 <ProfileOutline24Icon
                                    width="20px"
                                    height="20px"
                                    color="#ccc"
                                 />
                              )}
                              name="Profile"
                           />
                        </Link>
                     </GridCell>
                     <GridCell>
                        <Link to={isAdmin ? '/admin' : '/profile/me/settings'}>
                           <ToolsBlockButton
                              icon={(
                                 <AdminWorkspace24Icon
                                    width="22px"
                                    height="22px"
                                    color="#ccc"
                                 />
                              )}
                              name={isAdmin ? 'Admin Workspace' : 'Account Settings'}
                           />
                        </Link>
                     </GridCell>
                     <GridCell>
                        <Link to="/account/logout">
                           <ToolsBlockButton
                              icon={(
                                 <LogoutOutline24Icon
                                    width="20px"
                                    height="20px"
                                    color="#ccc"
                                 />
                              )}
                              name="Logout"
                           />
                        </Link>
                     </GridCell>
                  </Grid>
               </View>
               {/* Prototype control to test different view modes */}
               {isMotherUser && (
                  <View float="left" width="100%" padding="0 15px 15px 15px">
                     <Grid columns="4" spacing="5px">
                        <GridCell colspan="4">
                           <View
                              borderTop="1px solid #222"
                              padding="15px 0px 10px 0px">
                              <Text size="1.5" weight="medium" color="#fff">Dev Tools</Text>
                           </View>
                        </GridCell>
                        <GridCell>
                           <Link to="/ops">
                              <ToolsBlockButton
                                 name="Ops Center"
                                 icon={(
                                    <View
                                       position="relative"
                                       textAlign="left"
                                       border="1px dotted #888"
                                       borderRadius="2px"
                                       width="24px"
                                       height="24px"
                                    />
                                 )}
                              />
                           </Link>
                        </GridCell>
                        <GridCell>
                           <Link to="/dev/launchpad">
                              <ToolsBlockButton
                                 name="Dev Center"
                                 icon={(
                                    <View
                                       position="relative"
                                       textAlign="left"
                                       border="1px dotted #888"
                                       borderRadius="2px"
                                       width="24px"
                                       height="24px"
                                    />
                                 )}
                              />
                           </Link>
                        </GridCell>
                        <GridCell>
                           <ToolsBlockButton
                              onClick={() => {
                                 setProtoTheme({
                                    ...protoTheme,
                                    tmpViewMode: 'toc',
                                    tmpNoteMaxWidth: '600px'
                                 })
                                 setUseFacingPages(false)
                              }}
                              name="TOC"
                              icon={(
                                 <View
                                    border="1px solid #888"
                                    borderRadius="2px"
                                    width="24px"
                                    height="18px"
                                 />
                              )}
                           />
                        </GridCell>
                        <GridCell>
                           <ToolsBlockButton
                              onClick={() => {
                                 setProtoTheme({
                                    ...protoTheme,
                                    tmpViewMode: 'toc',
                                    tmpNoteMaxWidth: '100%'
                                 })
                                 setUseFacingPages(true)
                              }}
                              name="TOC Facing"
                              icon={(
                                 <View
                                    position="relative"
                                    border="1px solid #888"
                                    borderRadius="2px"
                                    width="24px"
                                    height="18px">
                                    <View
                                       position="absolute"
                                       top="0px"
                                       right="50%"
                                       bottom="0px"
                                       borderLeft="1px solid #888"
                                    />
                                 </View>
                              )}
                           />
                        </GridCell>
                        <GridCell>
                           <ToolsBlockButton
                              onClick={() => {
                                 setProtoTheme({
                                    ...protoTheme,
                                    tmpGlobalLayout: 'sidebar',
                                    tmpViewMode: 'sidebar',
                                    tmpNoteMaxWidth: '600px'
                                 })
                                 setUseFacingPages(false)
                              }}
                              name="Sidebar Layout"
                              icon={(
                                 <View
                                    position="relative"
                                    textAlign="left"
                                    border="1px solid #ac7979"
                                    borderRadius="2px"
                                    width="24px"
                                    height="18px">
                                    <View
                                       position="absolute"
                                       top="0px"
                                       left="7px"
                                       bottom="0px"
                                       borderRight="1px solid #ac7979"
                                    />
                                 </View>
                              )}
                           />
                        </GridCell>
                        <GridCell>
                           <Link
                              to="/"
                              onClick={() => {
                                 setProtoTheme({ ...protoTheme, tmpGlobalLayout: 'box' })
                                 setUseFacingPages(false)
                              }}>
                              <ToolsBlockButton
                                 name="Box Layout"
                                 icon={(
                                    <View
                                       position="relative"
                                       textAlign="left"
                                       border="1px solid #7d9a98"
                                       borderRadius="2px"
                                       width="24px"
                                       height="18px">
                                       <View
                                          position="absolute"
                                          top="4px"
                                          left="0px"
                                          right="0px"
                                          borderTop="1px solid #7d9a98"
                                       />
                                       <View
                                          position="absolute"
                                          top="4px"
                                          left="4px"
                                          right="4px"
                                          bottom="0px"
                                          borderRight="1px solid #7d9a98"
                                          borderLeft="1px solid #7d9a98"
                                       />
                                    </View>
                                 )}
                              />
                           </Link>
                        </GridCell>
                        <GridCell>
                           <Link
                              to="/"
                              onClick={() => {
                                 setProtoTheme({ ...protoTheme, tmpGlobalLayout: 'header' })
                                 setUseFacingPages(false)
                              }}>
                              <ToolsBlockButton
                                 name="Header Layout"
                                 icon={(
                                    <View
                                       position="relative"
                                       border="1px solid #7ca77c"
                                       borderRadius="2px"
                                       width="24px"
                                       height="18px">
                                       <View
                                          position="absolute"
                                          top="4px"
                                          right="0px"
                                          left="0px"
                                          borderTop="1px solid #7ca77c"
                                       />
                                    </View>
                                 )}
                              />
                           </Link>
                        </GridCell>
                     </Grid>
                  </View>
               )}
            </View>
         </Popover.View>
      </Popover.Provider>
   )
}

ToolsBlock.propTypes = {
   popoverAnchorOriginHorizontal: PropTypes.oneOf(['left', 'right']),
   popoverAnchorOriginVertical: PropTypes.oneOf(['bottom', 'top']),
   popoverMargin: PropTypes.string
}

ToolsBlock.defaultProps = {
   popoverAnchorOriginHorizontal: 'right',
   popoverAnchorOriginVertical: 'bottom',
   popoverMargin: '0px'
}

export default ToolsBlock
